var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dumbapp-preview",class:{card: _vm.card}},[(_vm.dumbapp)?_vm._l((_vm.dumbapp.steps),function(step,i){return _c('DumbappPreviewStep',{key:_vm.dumbapp.shortcode + '-' + i,staticClass:"step",attrs:{"step":step,"index":i}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }